import React from 'react';
import { Route, Switch } from 'react-router';
import Disciplines from './disciplines';
import Users from './users';
import TaskTypes from './tasktypes';
import ESYs from './esys';
import Placements from './placements';
import Districts from './districts';
import Schools from './schools';
import Programs from './programs';
import Rates from './rates';
import Proofing from './proofing';
import TimesheetSearch from './timesheetSearch';
import DisciplineGroups from './disciplineGroups';
import Divisions from './divisions';
import Therapists from './therapists';
import DisciplineGroupRules from './disciplineGroupRules';

const Admin = () => {
  return (
    <Switch>
      <Route path='/admin/disciplines/groups' component={DisciplineGroups} />
      <Route path='/admin/disciplines' component={Disciplines} />
      <Route path='/admin/task-types' component={TaskTypes} />
      <Route path='/admin/esys' component={ESYs} />
      <Route path='/admin/placements' component={Placements} />
      <Route path='/admin/users' component={Users} />
      <Route path='/admin/proofing' component={Proofing} />
      <Route path='/admin/timesheetSearch' component={TimesheetSearch} />
      <Route path='/admin/districts/:districtId/schools' component={Schools} />
      <Route path='/admin/districts/:districtId/programs' component={Programs} />
      <Route path='/admin/districts/:districtId/rates' component={Rates} />
      <Route path='/admin/districts' component={Districts} />
      <Route path='/admin/divisions' component={Divisions} />
      <Route path='/admin/therapists' component={Therapists} />
      <Route path='/admin/disciplineGroupRules' component={DisciplineGroupRules} />
    </Switch>
  );
};

export default Admin;
